module.exports = __webpack_public_path__ + "img/dl_top_dh.0ce5be83.png";